module.exports = __webpack_public_path__ + "static/media/appcenter-register.8a2e5c88.svg";